// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/agent-queue/overview/page"
import Pending from "@/app/agent-queue/overview/loading"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/agent-queue/overview/")({
  component: PageComponent,
  pendingComponent: Pending,

})

function PageComponent() {
  usePageHead({ title: "AI đang gặp sự cố" })
  return <Page />
}
